// extracted by mini-css-extract-plugin
module.exports = {"label":"bL_bt","mobileOnly":"bL_hN","content":"bL_K","toggle":"bL_hP","darkMode":"bL_cX"};